import { MsInMinute } from '@shared/constants/times/ms-in-minute'

export const MsInHour: number = 60 * MsInMinute
